__webpack_require__.p = "https://static.flicknovelcdn.com/reader-website-static/prod_4830894_85_710acd3a/_next/";